import { Components, Theme } from '@mui/material';

export const MuiDialog: Components<Theme>['MuiDialog'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      '.MuiBackdrop-root': { backgroundColor: theme.palette.background.overlay },
    }),
    paper: ({ theme }) => {
      // In Dark mode, MUI v5 adds background image with opacity that
      // matches the elevation, so turn that off for dialogs
      const backgroundImageStyle =
        theme.palette.mode === 'light'
          ? {}
          : {
              backgroundImage: 'unset',
            };

      return {
        ...backgroundImageStyle,
        border: `1px solid ${theme.palette.divider}`,
      };
    },
    paperFullScreen: ({ theme }) => {
      // The default full screen behavior is literally full screen. This extra
      // css overrides that behavior to be full screen with a consistent margin between
      // the modal and the edges of the screen.

      const margin = theme.spacing(3);
      const marginPx = parseInt(margin, 10);
      const calcWidth = `calc(100vw - ${marginPx * 2}px)`;
      const calcHeight = `calc(100vh - ${marginPx * 2}px)`;

      return {
        width: calcWidth,
        maxWidth: calcWidth,
        height: calcHeight,
        maxHeight: calcHeight,
        margin: margin,
      };
    },
  },
};

export const MuiDialogTitle: Components<Theme>['MuiDialogTitle'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(1, 2),
    }),
  },
};
